import React from 'react'
import { Link } from 'react-router-dom'
import { Form, Button, Row, Col } from 'antd';
import { ValidationFormStep1 } from './ValidateRandomizationStep1.js';
import { ValidationFormStep2 } from './ValidateRandomizationStep2.js';
import { ValidationFormStep3 } from './ValidateRandomizationStep3.js';
import { ValidationFormStep4 } from './ValidateRandomizationStep4.js';
import { withNamespaces } from 'react-i18next';


class Validation extends React.Component {


    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['currentStepInt'] = this.props.currentStepInt
                values['currentStep'] = this.props.currentStep

                this.props.handleSubmit(values)
            }
        });
    };

    handleNext = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['currentStepInt'] = this.props.currentStepInt
                values['currentStep'] = this.props.currentStep

                this.props.handleNext(values)

            }
        });
    };


    previousButton() {
      let {currentStep, currentStepInt} = this.props
      if ( (currentStep === 'Step 2') || (currentStep === 'Step 3')  ) {
        return (
            <Form.Item style={{ marginLeft: '15px' }}>
                <Button type='primary' size='large' loading={this.props.loading} onClick={this.props.handlePrev}>
                    {this.props.i18n.t('Back')}
                </Button>
            </Form.Item>
        )
      }

      return null;
    }

    nextButton(){
      let {currentStep, currentStepInt} = this.props
      if ( (currentStep === 'Step 1') || (currentStep === 'Step 2') ) {
        return (
            <Form.Item>
                <Button type='primary' size='large' loading={this.props.loading} onClick={this.handleNext}>
                    {this.props.i18n.t('Next')}
                </Button>
            </Form.Item>
        )
      } else if (currentStep === 'Step 3')  {
        return (
            <Form.Item>
                <Button type='primary' size='large' loading={this.props.loading} onClick={this.handleNext}>
                    {this.props.i18n.t('Submit')}
                </Button>
            </Form.Item>
        )
      }

      return null;
    }



    render() {
        const { getFieldDecorator } = this.props.form;
        const { loading } = this.props;

        return (
            <Row>
                <Col>
                  {this.props.currentStep !== 'Step 4' && <h3 className='headline-default'>{this.props.i18n.t('NamespaceValidateRandomization:Validate Randomization')} - {this.props.currentStep}</h3>}
                    <Form onSubmit={this.handleSubmit}>

                                          {/*
                                            Step 1 - user enters userID, siteID, subjectID
                                            Step 2 - verifies that userID, siteID are valid, that the subject exists, and if they already have validation data and consent, and asks the user whether the recommended randomization values have been used
                                            Step 3 - user enters validation information
                                            Step 4 - Confirmation of validation process
                                          */}
                                          <ValidationFormStep1
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />
                                          <ValidationFormStep2
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            handleVialExpiryDatePickerChange={this.props.handleVialExpiryDatePickerChange}
                                            subjectID={this.props.subjectID}
                                            subject={this.props.subject}
                                            randomizationPatientDiedDate={this.props.randomizationPatientDiedDate}
                                            actualUsedBottle={this.props.actualUsedBottle}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            randomizationDate={this.props.randomizationDate}
                                            randomizationGroup={this.props.randomizationGroup}
                                            randomizationWeight={this.props.randomizationWeight}
                                            randomizationTNKDose={this.props.randomizationTNKDose}
                                            randomizationTPABolusDose={this.props.randomizationTPABolusDose}
                                            randomizationTPAInfusionDose={this.props.randomizationTPAInfusionDose}
                                            consentExists={this.props.consentExists}
                                            validationExists={this.props.validationExists}
                                            validationExistsDate={this.props.validationExistsDate}
                                            validationExistsUsedRecommendedValues={this.props.validationExistsUsedRecommendedValues}
                                            deviationExists={this.props.deviationExists}
                                            validationExistsDeviationOccurred={this.props.validationExistsDeviationOccurred}
                                            validationPatientReceivedDifferentDrug={this.props.validationPatientReceivedDifferentDrug}
                                            validationPatientReturnedtDrug={this.props.validationPatientReturnedtDrug}
                                            validationPatientDied={this.props.validationPatientDied}
                                            validationPatientDiedComments={this.props.validationPatientDiedComments}
                                            validationDeviationExistsComments={this.props.validationDeviationExistsComments}
                                            validationExistsWeight={this.props.validationExistsWeight}
                                            validationExistsGroup={this.props.validationExistsGroup}
                                            validationExistsTNKDose={this.props.validationExistsTNKDose}
                                            validationExistsTPABolusDose={this.props.validationExistsTPABolusDose}
                                            validationExistsTPAInfusionDose={this.props.validationExistsTPAInfusionDose}
                                            validationExistsComments={this.props.validationExistsComments}
                                            validationExistsOptimizeRegistryID={this.props.validationExistsOptimizeRegistryID}
                                            validationExistsVialNumber={this.props.validationExistsVialNumber}
                                            saeExists={this.props.saeExists}
                                            validationExistsVialExpiryDate={this.props.validationExistsVialExpiryDate}
                                            validationExistsVialExpiryDateMoment={this.props.validationExistsVialExpiryDateMoment}
                                            validationPatientDiedDate={this.props.validationPatientDiedDate}
                                            validationPatientDiedDateMoment={this.props.validationPatientDiedDateMoment}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />
                                          <ValidationFormStep3
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            handleVialExpiryDatePickerChange={this.props.handleVialExpiryDatePickerChange}
                                            handlePatientDiedDatePickerChange={this.props.handlePatientDiedDatePickerChange}
                                            subjectID={this.props.subjectID}
                                            subject={this.props.subject}
                                            actualUsedBottle={this.props.actualUsedBottle}
                                            randomizationPatientDiedDate={this.props.randomizationPatientDiedDate}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            randomizationDate={this.props.randomizationDate}
                                            randomizationGroup={this.props.randomizationGroup}
                                            randomizationWeight={this.props.randomizationWeight}
                                            randomizationTNKDose={this.props.randomizationTNKDose}
                                            randomizationTPABolusDose={this.props.randomizationTPABolusDose}
                                            randomizationTPAInfusionDose={this.props.randomizationTPAInfusionDose}
                                            consentExists={this.props.consentExists}
                                            validationExists={this.props.validationExists}
                                            validationExistsDate={this.props.validationExistsDate}
                                            validationExistsUsedRecommendedValues={this.props.validationExistsUsedRecommendedValues}
                                            deviationExists={this.props.deviationExists}
                                            validationExistsDeviationOccurred={this.props.validationExistsDeviationOccurred}
                                            validationPatientReceivedDifferentDrug={this.props.validationPatientReceivedDifferentDrug}
                                            validationPatientReturnedtDrug={this.props.validationPatientReturnedtDrug}
                                            validationPatientDied={this.props.validationPatientDied}
                                            validationPatientDiedComments={this.props.validationPatientDiedComments}
                                            validationDeviationExistsComments={this.props.validationDeviationExistsComments}
                                            validationExistsWeight={this.props.validationExistsWeight}
                                            validationExistsGroup={this.props.validationExistsGroup}
                                            validationExistsTNKDose={this.props.validationExistsTNKDose}
                                            validationExistsTPABolusDose={this.props.validationExistsTPABolusDose}
                                            validationExistsTPAInfusionDose={this.props.validationExistsTPAInfusionDose}
                                            validationExistsComments={this.props.validationExistsComments}
                                            validationExistsOptimizeRegistryID={this.props.validationExistsOptimizeRegistryID}
                                            validationExistsVialNumber={this.props.validationExistsVialNumber}
                                            validationExistsVialExpiryDate={this.props.validationExistsVialExpiryDate}
                                            validationExistsVialExpiryDateMoment={this.props.validationExistsVialExpiryDateMoment}
                                            validationPatientDiedDate={this.props.validationPatientDiedDate}
                                            validationPatientDiedDateMoment={this.props.validationPatientDiedDateMoment}
                                            submitted={this.props.submitted}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />
                                          <ValidationFormStep4
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            subjectID={this.props.subjectID}
                                            subject={this.props.subject}
                                            actualUsedBottle={this.props.actualUsedBottle}
                                            randomizationPatientDiedDate={this.props.randomizationPatientDiedDate}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            randomizationDate={this.props.randomizationDate}
                                            randomizationGroup={this.props.randomizationGroup}
                                            randomizationWeight={this.props.randomizationWeight}
                                            randomizationTNKDose={this.props.randomizationTNKDose}
                                            randomizationTPABolusDose={this.props.randomizationTPABolusDose}
                                            randomizationTPAInfusionDose={this.props.randomizationTPAInfusionDose}
                                            consentExists={this.props.consentExists}
                                            validationExists={this.props.validationExists}
                                            saeExists={this.props.saeExists}
                                            validationExistsDate={this.props.validationExistsDate}
                                            validationExistsUsedRecommendedValues={this.props.validationExistsUsedRecommendedValues}
                                            deviationExists={this.props.deviationExists}
                                            validationExistsDeviationOccurred={this.props.validationExistsDeviationOccurred}
                                            validationPatientReceivedDifferentDrug={this.props.validationPatientReceivedDifferentDrug}
                                            validationPatientReturnedtDrug={this.props.validationPatientReturnedtDrug}
                                            validationPatientDied={this.props.validationPatientDied}
                                            validationPatientDiedComments={this.props.validationPatientDiedComments}
                                            validationDeviationExistsComments={this.props.validationDeviationExistsComments}
                                            validationExistsWeight={this.props.validationExistsWeight}
                                            validationExistsGroup={this.props.validationExistsGroup}
                                            validationExistsTNKDose={this.props.validationExistsTNKDose}
                                            validationExistsTPABolusDose={this.props.validationExistsTPABolusDose}
                                            validationExistsTPAInfusionDose={this.props.validationExistsTPAInfusionDose}
                                            validationExistsComments={this.props.validationExistsComments}
                                            validationExistsOptimizeRegistryID={this.props.validationExistsOptimizeRegistryID}
                                            validationExistsVialNumber={this.props.validationExistsVialNumber}
                                            validationExistsVialExpiryDate={this.props.validationExistsVialExpiryDate}
                                            validationExistsVialExpiryDateMoment={this.props.validationExistsVialExpiryDateMoment}
                                            validationPatientDiedDate={this.props.validationPatientDiedDate}
                                            validationPatientDiedDateMoment={this.props.validationPatientDiedDateMoment}
                                            submitted={this.props.submitted}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />


                                        <div style={{ display: 'flex' }}>
                                          {this.nextButton()}
                                          {this.previousButton()}
                                        </div>


                    </Form>
                </Col>
            </Row>
        )
    }
}


const ValidationForm = Form.create()(withNamespaces()(Validation));
 
export default ValidationForm;



// WEBPACK FOOTER //
// ./src/components/ValidateRandomization/ValidateRandomization.js